import { useState, useEffect, useRef } from "react";
import { Nav, NavItem, NavLink, Button, Row, Col, Badge } from "reactstrap";
import Select from "react-select";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

function APLTabs({
  toggleCreatePeriod,
  toggleExportModal,
  toggleEditSupervisors,
  periodsToSelect,
  period,
  activeTab,
  handleSelectPeriod,
  selectedPeriod,
  handleSetAplTab,
  isMobile = false,
  unviewedCount = 0,
  unviewedCountsByPeriod = {},
}) {
  const fadeTimerRef = useRef(null);
  const [badgeVisible, setBadgeVisible] = useState(unviewedCount > 0);
  const [badgeFadingOut, setBadgeFadingOut] = useState(false);
  const displayCountRef = useRef(unviewedCount);

  useEffect(() => {
    if (fadeTimerRef.current) {
      clearTimeout(fadeTimerRef.current);
      fadeTimerRef.current = null;
    }

    if (unviewedCount > 0) {
      displayCountRef.current = unviewedCount;
      setBadgeVisible(true);
      setBadgeFadingOut(false);
    } else if (badgeVisible) {
      setBadgeFadingOut(true);
      fadeTimerRef.current = setTimeout(() => {
        setBadgeVisible(false);
        setBadgeFadingOut(false);
      }, 400);
    }
    return () => {
      if (fadeTimerRef.current) {
        clearTimeout(fadeTimerRef.current);
      }
    };
  }, [unviewedCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const linkClass = (id) =>
    classNames("apl-subtab-link", {
      "apl-subtab-link--active": activeTab === id,
      "apl-subtab-link--inactive": activeTab !== id,
    });

  const formatPeriodOptionLabel = (option) => {
    const count = unviewedCountsByPeriod[option.value] || 0;
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span>{option.label}</span>
        {count > 0 && (
          <Badge color="danger" pill className="ms-2">
            {count}
          </Badge>
        )}
      </div>
    );
  };

  const tabs = [
    { id: 4, messageId: "AdministerPeriod" },
    { id: 1, messageId: "Presence" },
    { id: 2, messageId: "Workcard" },
    { id: 3, messageId: "WorkcardFeed" },
  ];

  return (
    <div>
      <div
        className={isMobile ? "teacher-tab--mobile" : "apl-subtabs-no-scroll"}
      >
        <Nav
          tabs
          className={classNames("apl-subtabs", {
            "teacher-tab--mobile": isMobile,
          })}
        >
          {period &&
            tabs.map((t) => (
              <NavItem key={t.id}>
                <NavLink
                  className={linkClass(t.id)}
                  active={activeTab === t.id}
                  onClick={() => handleSetAplTab(t.id)}
                >
                  <FormattedMessage id={t.messageId} />
                  {t.id === 3 && badgeVisible && (
                    <Badge
                      color="danger"
                      pill
                      className={classNames("ms-2 apl-badge-notify", {
                        "apl-badge-notify--out": badgeFadingOut,
                      })}
                    >
                      {displayCountRef.current}
                    </Badge>
                  )}
                </NavLink>
              </NavItem>
            ))}
        </Nav>
      </div>

      <div className="mt-3">
        {isMobile ? (
          <div className="d-flex flex-column">
            <Button
              color="primary"
              className="m-3"
              onClick={toggleCreatePeriod}
            >
              <FontAwesomeIcon icon="plus" className="me-1" />
              <FormattedMessage id="NewAplPeriod" />
            </Button>
            <Button
              color="primary"
              outline
              className="ms-3 me-3 mb-3"
              onClick={toggleEditSupervisors}
            >
              <FontAwesomeIcon icon="user-edit" className="me-1" />
              <FormattedMessage id="EditSupervisors" />
            </Button>
            {period && (
              <Button
                color="primary"
                outline
                className="ms-3 me-3 mb-3"
                onClick={toggleExportModal}
              >
                <FontAwesomeIcon icon="file-excel" className="me-1" />
                <FormattedMessage id="ExportToExcel" />
              </Button>
            )}

            <Select
              menuPortalTarget={document.body}
              className="ms-3 me-3"
              styles={{
                padding: 0,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPosition={"fixed"}
              options={periodsToSelect}
              value={
                selectedPeriod
                  ? selectedPeriod
                  : { value: null, label: "Välj period" }
              }
              onChange={(event) => {
                handleSelectPeriod(event);
              }}
              placeholder="Välj period"
              formatOptionLabel={formatPeriodOptionLabel}
            />
          </div>
        ) : (
          <Row className="align-items-center">
            <Col xs="10" md="6" lg="5" className="ms-2 pe-1">
              <Select
                menuPortalTarget={document.body}
                styles={{
                  padding: 0,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPosition={"fixed"}
                options={periodsToSelect}
                value={
                  selectedPeriod
                    ? selectedPeriod
                    : { value: null, label: "Välj period" }
                }
                onChange={(event) => {
                  handleSelectPeriod(event);
                }}
                placeholder="Välj period"
                formatOptionLabel={formatPeriodOptionLabel}
              />
            </Col>
            <Col className="ps-1">
              <Button color="primary" onClick={toggleCreatePeriod}>
                <FontAwesomeIcon icon="plus" className="me-1" />
                <FormattedMessage id="NewAplPeriod" />
              </Button>
              <Button
                color="primary"
                outline
                className="ms-2"
                onClick={toggleEditSupervisors}
              >
                <FontAwesomeIcon icon="user-edit" className="me-1" />
                <FormattedMessage id="EditSupervisors" />
              </Button>
              {period && (
                <Button
                  color="primary"
                  outline
                  className="ms-2"
                  onClick={toggleExportModal}
                >
                  <FontAwesomeIcon icon="file-excel" className="me-1" />
                  <FormattedMessage id="ExportToExcel" />
                </Button>
              )}
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}

export default APLTabs;
